"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmCancelModalBody = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const dayjs_1 = __importDefault(require("dayjs"));
const ConfirmCancelModalBody = ({ appointment, status, bookingFlowType, }) => {
    const { fromDate, location } = appointment;
    const modalBody = (0, react_1.useMemo)(() => {
        const successMessage = bookingFlowType === 'cancel'
            ? __.trans('booking.cancellation-success')
            : __.trans('booking.confirmation-successful');
        const errorMessage = bookingFlowType === 'cancel'
            ? __.trans('booking.cancellation-error')
            : __.trans('booking.confirmation-unsuccessful');
        switch (status) {
            case 'OK':
                return (0, jsx_runtime_1.jsx)("h4", { children: successMessage });
            case 'ERROR':
                return (0, jsx_runtime_1.jsx)("h4", { className: "text-danger", children: errorMessage });
            default:
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { children: __.trans('booking.modal-time') }), (0, jsx_runtime_1.jsx)("p", { className: "capitalize", children: `${(0, dayjs_1.default)(fromDate).format('dddd D MMMM YYYY')}, kl. ${(0, dayjs_1.default)(fromDate).format('HH:mm')}` })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { children: __.trans('booking.blood-central') }), (0, jsx_runtime_1.jsx)("p", { children: location.name })] }), (0, jsx_runtime_1.jsx)("div", { className: "booking-info-text", children: (0, jsx_runtime_1.jsx)("p", { children: __.trans('booking.modal-info-cancelation-text') }) })] }));
        }
    }, [status, fromDate, location.name, bookingFlowType]);
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: modalBody });
};
exports.ConfirmCancelModalBody = ConfirmCancelModalBody;
exports.default = exports.ConfirmCancelModalBody;
